import defaultSettings from '@/settings'

// const title = defaultSettings.title || 'Vue Admin Template'
const title = 'Login'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle}`
  }
  return `${title}`
}
